// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-field-row {
  display: flex;
  align-items: center;
}
.input-field-row formly-field {
  flex: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/formly/repeat.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;AACJ;AACI;EAEI,OAAA;AAAR","sourcesContent":[".input-field-row {\n    display: flex;\n    align-items: center;\n\n    formly-field {\n        // Let the formly field take up the remaining space in the row\n        flex: 1;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
